import { useEffect, useId, useState } from 'react';

export const useVisible = (): [boolean, string] => {
  const id = useId();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );
    const selectorEscaped = id.replace(/([:.])/g, '\\$1');

    const section = document.querySelector(`#${selectorEscaped}`);

    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [isVisible, id];
};
